@if (!isAuthenticated) {
  <div class="flex flex-col lg:flex-row text-center">
    <span>Have account credit or digital wallet?</span>
    <a (click)="signInRedirect()" class="ml-5"
      >Login to your {{ configurationService.configuration.clientName }} account
      to use it.</a
    >
  </div>
} @else {
  <div class="flex flex-col lg:flex-row items-center justify-center gap-4">
    <span>Welcome {{ patronName }}</span>
    <button (click)="signOut()" class="btn-main">Sign out</button>
  </div>
}
